import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { permissionGuard } from './shared/guards/permission.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login').then((m) => m.LoginPage),
  },
  {
    path: '',
    loadComponent: () => import('./layouts/main-layout/main-layout').then((m) => m.MainLayout),
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () => import('./pages/main/home/home').then((m) => m.HomePage),
      },
      {
        path: 'news',
        loadComponent: () => import('./pages/main/news/news').then((m) => m.NewsPage),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./pages/main/search-posts/search-posts').then((m) => m.SearchPostsPage),
      },
      {
        path: 'tag/:slug',
        loadComponent: () => import('./pages/main/tag-posts/tag-posts').then((m) => m.TagPostsPage),
      },
      {
        path: 'news/:slug',
        loadComponent: () =>
          import('./pages/main/news-detail/news-detail').then((m) => m.NewsDetailPage),
      },
      {
        path: 'careers',
        loadComponent: () => import('./pages/main/careers/careers').then((m) => m.CareersPage),
      },
      {
        path: 'careers/:id',
        loadComponent: () =>
          import('./pages/main/career-detail/career-detail').then((m) => m.CareerDetailPage),
      },
      {
        path: 'about',
        loadComponent: () => import('./pages/main/about/about').then((m) => m.AboutPage),
      },
      {
        path: 'contact',
        loadComponent: () => import('./pages/main/contact/contact').then((m) => m.ContactPage),
      },
      {
        path: 'pricing',
        loadComponent: () => import('./pages/main/services/services').then((m) => m.ServicesPage),
      },
      // Đường dẫn cũ: chuyển sang /pricing để link đã chia sẻ vẫn mở được
      {
        path: 'services',
        redirectTo: 'pricing',
        pathMatch: 'full',
      },
      {
        path: 'personal-data-protection-policy',
        loadComponent: () => import('./pages/main/policy/personal-data-protection-policy').then((m) => m.PersonalDataProtectionPolicyPage),
      },
      {
        path: 'security-principles',
        loadComponent: () => import('./pages/main/policy/security-principles').then((m) => m.SecurityPrinciplesPage),
      }
      ,
      {
        path: 'data-processing-terms',
        loadComponent: () => import('./pages/main/policy/data-processing-terms').then((m) => m.DataProcessingTermsPage),
      },
      {
        path: 'general-transaction-conditions',
        loadComponent: () => import('./pages/main/policy/general-transaction-conditions').then((m) => m.GeneralTransactionConditionsPage),
      },
      {
        path: 'complaint-resolution-policy',
        loadComponent: () => import('./pages/main/policy/complaint-resolution-policy').then((m) => m.ComplaintResolutionPolicyPage),
      },
      {
        path: 'shipping-delivery-policy',
        loadComponent: () => import('./pages/main/policy/shipping-delivery-policy').then((m) => m.ShippingDeliveryPolicyPage),
      },
      {
        path: 'hkd-tax-calculator',
        loadComponent: () => import('./pages/main/hkd-tax-calculator/hkd-tax-calculator').then((m) => m.HkdTaxCalculatorPage),
      },
      {
        path: 'guide',
        loadComponent: () => import('./pages/main/instructs/instructs').then((m) => m.InstructsPage),
      },
      {
        path: 'guide/:slug',
        loadComponent: () => import('./pages/main/instructs/instructs').then((m) => m.InstructsPage),
      },
      // Đường dẫn cũ: chuyển sang /guide để link đã chia sẻ vẫn mở được
      {
        path: 'huong-dan',
        redirectTo: 'guide',
        pathMatch: 'full',
      },
      {
        path: 'huong-dan/:slug',
        redirectTo: 'guide/:slug',
      },
    ],
  },
  {
    path: 'admin',
    loadComponent: () => import('./layouts/admin-layout/admin-layout').then((m) => m.AdminLayout),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'posts',
        pathMatch: 'full',
      },
      {
        path: 'posts',
        loadComponent: () => import('./pages/admin/posts/posts').then((m) => m.PostsPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'posts' },
      },
      {
        path: 'tags',
        loadComponent: () => import('./pages/admin/tags/tags').then((m) => m.TagsPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'tags' },
      },
      {
        path: 'careers',
        loadComponent: () => import('./pages/admin/careers/careers').then((m) => m.CareersPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'careers' },
      },
      {
        path: 'contacts',
        loadComponent: () => import('./pages/admin/contacts/contacts').then((m) => m.Contacts),
        canActivate: [permissionGuard],
        data: { functionCode: 'contacts' },
      },
      {
        path: 'ecosystem',
        loadComponent: () => import('./pages/admin/ecosystem/ecosystem-admin').then((m) => m.EcosystemAdminPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'ecosystem' },
      },
      {
        path: 'services',
        loadComponent: () => import('./pages/admin/services/services').then((m) => m.AdminServicesPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'services' },
      },
      {
        path: 'pricing',
        loadComponent: () => import('./pages/admin/pricing/pricing').then((m) => m.AdminPricingPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'pricing' },
      },
      {
        path: 'accounts',
        loadComponent: () => import('./pages/admin/accounts/accounts').then((m) => m.AccountsPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'accounts' },
      },
      {
        path: 'roles',
        loadComponent: () => import('./pages/admin/roles/roles').then((m) => m.RolesPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'roles' },
      },
      {
        path: 'team',
        loadComponent: () => import('./pages/admin/team/team-admin').then((m) => m.TeamAdminPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'team' },
      },
      {
        path: 'instructs',
        loadComponent: () => import('./pages/admin/instructs/instructs-admin').then((m) => m.InstructsAdminPage),
        canActivate: [permissionGuard],
        data: { functionCode: 'instructs' },
      },
      {
        path: 'no-access',
        loadComponent: () => import('./pages/admin/no-access/no-access').then((m) => m.NoAccessPage),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
